import { render } from "./SelectLesson.vue?vue&type=template&id=33f00eda&scoped=true"
import script from "./SelectLesson.vue?vue&type=script&lang=js"
export * from "./SelectLesson.vue?vue&type=script&lang=js"

import "./SelectLesson.vue?vue&type=style&index=0&id=33f00eda&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f00eda"]])

export default __exports__